import React from 'react';
import Modal from '../../Components/Modal';
import Form, { RequiredValidator, TextField, Switch, Actions, ULID} from '../../Components/Form';
import { useToasts } from '../../Components/Toasts';
import API from '../../Services/API';
import { useSession } from '../../Components/Session';

const EditRound = ({round, isOpen, onClose, onSave}) => {

    return <Modal isOpen={isOpen} setIsOpen={onClose} dismissible>

        {round && <Inner {...{round, ...{onClose, onSave}}} />}

    </Modal>
}

const Inner = ({round, onSave}) => {
    const {hasFeature} = useSession();
    const {showSuccess, showAlert} = useToasts();

    const handleSave = (data) => {
        return API.post('/rounds'+(round?.id ? '/'+round.id : ''), data)
            .then(() => showSuccess('Round saved'))
            .catch((err) => showAlert(API.parseErrorResponse(err)));
    }

    return <Form onSubmit={handleSave} data={round} afterSubmit={onSave} closeModalOnSubmit>
        <TextField label="Round Name" name="name" validators={[RequiredValidator]} />
        <Switch label="Keep optimised"
            disabled={!hasFeature('ROUTE_OPTIMISATION')}
            name="keepOptimised"
            help={(on) => {
                if (!hasFeature('ROUTE_OPTIMISATION')) {
                    return 'Route optimisation is not available in your current plan.';
                }
                if (on) {
                    return 'As jobs are added or removed from the round the order will automatically updated to keep it optimised.';
                }

                return 'The order of jobs will not be automatically updated as jobs are added or removed from the round.'
            }}
        />
        <ULID name="roundId" />
        <Actions submit cancel />
    </Form>
}

export default EditRound;
